import { client, BASE_URL } from "./client.ts";

const base_url = "/inspect-rule";

export const getInspRule = async (params) => {
  try {
    const response = await client.get(`${base_url}`, { params });
    const extractedData = response.data.data.contents.map((ruleData) => ({
      ...ruleData,
      name: ruleData.name ? ruleData.name : "-",
      model_uuid: ruleData.model ? ruleData.model.uuid : null,
      model_name: ruleData.model ? ruleData.model.name : null,
      model_description: ruleData.model.description
        ? ruleData.model.description
        : null,
    }));
    const totalItems = response.data.data.total_count;
    return { extractedData, totalItems };
  } catch (error) {
    return { extractedData: null, totalItems: null };
  }
};

// 검사규칙 추가
export const addInspRule = async (ruleInfo) => {
  try {
    const response = await client.post(base_url, {
      ...ruleInfo,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

//  검사규칙 수정
export const editInspRule = async (uuid, ruleInfo) => {
  try {
    const response = await client.patch(`${base_url}/${uuid}`, {
      ...ruleInfo,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 검사규칙 삭제
export const deleteInspRule = async (id) => {
  try {
    const response = await client.delete(`${base_url}/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 검사규칙 단일조회
export const getInspRuleDetail = async (id) => {
  try {
    const response = await client.get(`${base_url}/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
